import {
  primaryEntityActionButtonClass,
  secondaryEntityActionButtonClass,
} from "@/components/ui/entityActionButtonClasses"
import { cn } from "@/lib/utils/helpers"
import type { TransferProcessWizardFooterProps } from "../types"

/** Previous / Next / Finish / Transfer / Exit controls below tab panels. */
export function TransferProcessWizardFooter({ ctx }: TransferProcessWizardFooterProps) {
  const {
    selectedTab,
    fragment,
    residents,
    applications,
    selectedResidentList,
    selectedApplicationList,
    transferResident,
    completeSplitPropertyTransfer,
    currentTabIndex,
    previousTab,
    nextDisabled,
    nextTab,
  } = ctx

  const primaryClass = cn(
    primaryEntityActionButtonClass,
    "min-h-[44px] w-full sm:min-h-0 sm:w-auto",
  )
  const secondaryClass = cn(
    secondaryEntityActionButtonClass,
    "min-h-[44px] w-full sm:min-h-0 sm:w-auto",
  )

  return (
    <>
      {selectedTab !== "summaryinfo" && (
        <div
          data-testid="transfer-process-wizard-footer-nav"
          className="mt-8 flex w-full min-w-0 flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-end sm:justify-end"
        >
          <button
            type="button"
            data-testid="transfer-process-wizard-previous-button"
            disabled={currentTabIndex <= 0}
            onClick={previousTab}
            className={secondaryClass}
          >
            Previous
          </button>
          <div className="flex w-full flex-col gap-6 sm:w-auto sm:items-end">
            {selectedTab === "residentinfo" &&
              fragment === "transfer_resident" &&
              (residents.length > 0 || applications.length > 0) && (
                <button
                  type="button"
                  data-testid="transfer-process-residents-transfer-submit-button"
                  disabled={!selectedResidentList.length && !selectedApplicationList.length}
                  onClick={() => void transferResident()}
                  className={cn(primaryClass, "sm:shrink-0")}
                >
                  Transfer
                </button>
              )}
            {selectedTab === "residentinfo" &&
              fragment === "split_property" &&
              (residents.length > 0 || applications.length > 0) && (
                <button
                  type="button"
                  data-testid="transfer-process-split-residents-transfer-submit-button"
                  disabled={!selectedResidentList.length && !selectedApplicationList.length}
                  onClick={() => void completeSplitPropertyTransfer()}
                  className={cn(primaryClass, "sm:shrink-0")}
                >
                  Transfer
                </button>
              )}
            <button
              type="button"
              data-testid={
                selectedTab === "residentinfo"
                  ? "transfer-process-wizard-finish-button"
                  : "transfer-process-wizard-next-button"
              }
              disabled={nextDisabled}
              onClick={() => void nextTab()}
              className={primaryClass}
            >
              {selectedTab === "residentinfo" ? "Finish" : "Next"}
            </button>
          </div>
        </div>
      )}
      {selectedTab === "summaryinfo" && (
        <div
          data-testid="transfer-process-summary-exit-footer"
          className="mt-8 flex w-full justify-stretch sm:justify-end"
        >
          <button
            type="button"
            data-testid="transfer-process-summary-exit-button"
            onClick={() => void nextTab()}
            className={primaryClass}
          >
            Exit
          </button>
        </div>
      )}
    </>
  )
}
